<template>
  <div>
    <v-row>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Division prefix'
          v-model='value.division_prefix'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Commercial project prefix'
          v-model='value.comm_project_letter'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Residential project prefix'
          v-model='value.ress_project_letter'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <wc-datepicker
          label='Season starts'
          v-model='value.season_starts'
        ></wc-datepicker>
      </v-col>
      <v-col cols='12' md='6'>
        <wc-datepicker
          label='Season ends'
          v-model='value.season_ends'
        ></wc-datepicker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Days until invoices are due'
          v-model='value.days_until_invoice_due'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Monthly invoice interest'
          v-model='value.invoice_interest'
          append-icon='mdi-percent'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Terms'
          v-model='value.invoice_terms'
        ></v-text-field>
     </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' md='4'>
        <v-text-field
          prepend-icon='mdi-currency-usd'
          label='Residential margin'
          :rules='[rules.decimal]'
          v-model='value.ressy_margin'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          prepend-icon='mdi-currency-usd'
          label='Commercial margin'
          :rules='[rules.decimal]'
          v-model='value.comm_margin'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='3' offset-md='1'>
        <v-text-field
          append-icon='mdi-percent'
          label='Estimate markup'
          :rules='[rules.decimal]'
          v-model='value.estimate_markup'
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
export default {
  name: 'division-details-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  }
}
</script>